var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"vote-progress":""}},[(_vm.voteModify)?_c('VoteModify',{attrs:{"info":_vm.info},on:{"close":function($event){_vm.voteModify = false}}}):_vm._e(),_c('VoteList',{attrs:{"info":_vm.info},on:{"modify":_vm.showModify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }